export default __webpack_public_path__ + "static/media/aglc_receiptv2_example_1.bcd12a92.png";